import ApplicationController from "./application_controller.js"

export default class extends ApplicationController {
  static targets = [ "packageSelector" ]

  connect() {
  }

  packageSelectionChanged(ev) {
    let checked = this.packageSelectorTargets.filter(el => el.checked)
    let href
    if (checked.length > 0) {
      let query = '?packages=' + checked.map(el => el.value).join()
      href = location.pathname + query
    } else {
      href = location.pathname
    }
    Turbolinks.visit(href, { action: 'replace' })
  }
}
